import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const PaymentsHistory = () => {
  const routes = all_routes;

  const [children] = useState([
    { id: "1", name: "Emma Johnson", grade: "10th", class: "10-A" },
    { id: "2", name: "James Johnson", grade: "8th", class: "8-B" },
  ]);

  const [selectedChildId, setSelectedChildId] = useState("1");
  const [activeTab, setActiveTab] = useState("history");
  const [selectedYear, setSelectedYear] = useState("2024");

  const selectedChild = children.find((child) => child.id === selectedChildId);

  // Mock payments data
  const paymentsData = {
    summary: {
      totalPaid: 5650,
      totalPending: 450,
      totalOverdue: 0,
      yearToDate: 5650,
      nextDueDate: "2024-09-15",
    },
    history: [
      {
        id: "1",
        description: "Tuition Fee - August 2024",
        amount: 500,
        dueDate: "2024-08-15",
        paidDate: "2024-08-14",
        status: "paid",
        method: "Credit Card",
        reference: "TXN-240814-001",
      },
      {
        id: "2",
        description: "Annual Day Event Fee",
        amount: 75,
        dueDate: "2024-08-20",
        paidDate: "2024-08-18",
        status: "paid",
        method: "Bank Transfer",
        reference: "TXN-240818-002",
      },
      {
        id: "3",
        description: "Library Fine",
        amount: 25,
        dueDate: "2024-08-10",
        paidDate: "2024-08-12",
        status: "paid",
        method: "Cash",
        reference: "TXN-240812-003",
      },
      {
        id: "4",
        description: "Tuition Fee - July 2024",
        amount: 500,
        dueDate: "2024-07-15",
        paidDate: "2024-07-13",
        status: "paid",
        method: "Credit Card",
        reference: "TXN-240713-004",
      },
      {
        id: "5",
        description: "Science Lab Equipment Fee",
        amount: 150,
        dueDate: "2024-07-20",
        paidDate: "2024-07-19",
        status: "paid",
        method: "Credit Card",
        reference: "TXN-240719-005",
      },
    ],
    pending: [
      {
        id: "6",
        description: "Tuition Fee - September 2024",
        amount: 500,
        dueDate: "2024-09-15",
        status: "pending",
        category: "Tuition",
      },
      {
        id: "7",
        description: "Sports Equipment Fee",
        amount: 120,
        dueDate: "2024-09-10",
        status: "pending",
        category: "Sports",
      },
    ],
    breakdown: [
      { category: "Tuition", amount: 4000, percentage: 70.8 },
      { category: "Events", amount: 450, percentage: 8.0 },
      { category: "Lab Fees", amount: 600, percentage: 10.6 },
      { category: "Sports", amount: 350, percentage: 6.2 },
      { category: "Library", amount: 250, percentage: 4.4 },
    ],
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "paid":
        return "success";
      case "pending":
        return "warning";
      case "overdue":
        return "danger";
      default:
        return "secondary";
    }
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case "paid":
        return "ti-check";
      case "pending":
        return "ti-clock";
      case "overdue":
        return "ti-alert-triangle";
      default:
        return "ti-circle";
    }
  };

  const getMethodIcon = (method: string) => {
    switch (method) {
      case "Credit Card":
        return "ti-credit-card";
      case "Bank Transfer":
        return "ti-building-bank";
      case "Cash":
        return "ti-cash";
      default:
        return "ti-wallet";
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row mb-4">
            <div className="col">
              <div className="d-flex align-items-center">
                <Link
                  to={routes.parentMenu}
                  className="btn btn-outline-secondary btn-sm me-3"
                >
                  <i className="ti ti-arrow-left"></i>
                </Link>
                <div>
                  <h3 className="page-title mb-1">Payments History</h3>
                  <p className="text-muted mb-0">
                    Payment records and upcoming dues
                  </p>
                </div>
              </div>
            </div>
            <div className="col-auto">
              {children.length > 1 && (
                <div className="dropdown">
                  <button
                    className="btn btn-outline-primary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-user me-2"></i>
                    {selectedChild?.name}
                  </button>
                  <ul className="dropdown-menu">
                    {children.map((child) => (
                      <li key={child.id}>
                        <button
                          className={`dropdown-item ${
                            selectedChildId === child.id ? "active" : ""
                          }`}
                          onClick={() => setSelectedChildId(child.id)}
                        >
                          {child.name} - {child.grade} {child.class}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>

          {/* Payment Summary */}
          <div className="row mb-4">
            <div className="col-md-3 col-sm-6">
              <div className="card bg-success-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-success mb-2">
                    <i className="ti ti-check text-white fs-2"></i>
                  </div>
                  <h4 className="text-success">
                    ${paymentsData.summary.totalPaid}
                  </h4>
                  <p className="mb-0">Total Paid</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-warning-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-warning mb-2">
                    <i className="ti ti-clock text-white fs-2"></i>
                  </div>
                  <h4 className="text-warning">
                    ${paymentsData.summary.totalPending}
                  </h4>
                  <p className="mb-0">Pending</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-danger-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-danger mb-2">
                    <i className="ti ti-alert-triangle text-white fs-2"></i>
                  </div>
                  <h4 className="text-danger">
                    ${paymentsData.summary.totalOverdue}
                  </h4>
                  <p className="mb-0">Overdue</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-primary-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-primary mb-2">
                    <i className="ti ti-calendar text-white fs-2"></i>
                  </div>
                  <h4 className="text-primary">Sep 15</h4>
                  <p className="mb-0">Next Due</p>
                </div>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="card">
            <div className="card-header">
              <div className="d-flex justify-content-between align-items-center">
                <ul className="nav nav-tabs" role="tablist">
                  <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeTab === "history" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("history")}
                    >
                      Payment History
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeTab === "pending" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("pending")}
                    >
                      Pending ({paymentsData.pending.length})
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeTab === "breakdown" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("breakdown")}
                    >
                      Breakdown
                    </button>
                  </li>
                </ul>
                {activeTab === "history" && (
                  <select
                    className="form-select w-auto"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                  >
                    <option value="2024">2024</option>
                    <option value="2023">2023</option>
                  </select>
                )}
              </div>
            </div>
            <div className="card-body">
              {/* Payment History Tab */}
              {activeTab === "history" && (
                <div>
                  {paymentsData.history.map((payment) => (
                    <div key={payment.id} className="card mb-3 border">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="d-flex align-items-center">
                            <div
                              className={`avatar avatar-sm bg-${getStatusColor(
                                payment.status
                              )} me-3`}
                            >
                              <i
                                className={`ti ${getStatusIcon(
                                  payment.status
                                )} text-white`}
                              ></i>
                            </div>
                            <div>
                              <h6 className="mb-1">{payment.description}</h6>
                              <p className="text-muted mb-0">
                                Reference: {payment.reference}
                              </p>
                            </div>
                          </div>
                          <div className="text-end">
                            <h5 className="text-success mb-1">
                              ${payment.amount}
                            </h5>
                            <span
                              className={`badge bg-${getStatusColor(
                                payment.status
                              )}`}
                            >
                              {payment.status}
                            </span>
                          </div>
                        </div>
                        <div className="row text-center">
                          <div className="col-3">
                            <small className="text-muted d-block">
                              Due Date
                            </small>
                            <span className="fw-semibold">
                              {new Date(payment.dueDate).toLocaleDateString()}
                            </span>
                          </div>
                          <div className="col-3">
                            <small className="text-muted d-block">
                              Paid Date
                            </small>
                            <span className="fw-semibold">
                              {new Date(payment.paidDate).toLocaleDateString()}
                            </span>
                          </div>
                          <div className="col-3">
                            <small className="text-muted d-block">Method</small>
                            <span className="fw-semibold d-flex align-items-center justify-content-center">
                              <i
                                className={`ti ${getMethodIcon(
                                  payment.method
                                )} me-1`}
                              ></i>
                              {payment.method}
                            </span>
                          </div>
                          <div className="col-3">
                            <button className="btn btn-outline-primary btn-sm">
                              <i className="ti ti-download me-1"></i>
                              Receipt
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Pending Payments Tab */}
              {activeTab === "pending" && (
                <div>
                  {paymentsData.pending.map((payment) => (
                    <div
                      key={payment.id}
                      className="card mb-3 border-warning border-start border-4"
                    >
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="d-flex align-items-center">
                            <div className="avatar avatar-sm bg-warning me-3">
                              <i className="ti ti-clock text-white"></i>
                            </div>
                            <div>
                              <h6 className="mb-1">{payment.description}</h6>
                              <p className="text-muted mb-0">
                                Category: {payment.category}
                              </p>
                            </div>
                          </div>
                          <div className="text-end">
                            <h5 className="text-warning mb-1">
                              ${payment.amount}
                            </h5>
                            <span className="badge bg-warning">Pending</span>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="text-muted">
                            Due:{" "}
                            {new Date(payment.dueDate).toLocaleDateString()}
                          </span>
                          <button className="btn btn-primary btn-sm">
                            <i className="ti ti-credit-card me-1"></i>
                            Pay Now
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Breakdown Tab */}
              {activeTab === "breakdown" && (
                <div>
                  <h6 className="mb-3">
                    Payment Breakdown by Category ({selectedYear})
                  </h6>
                  {paymentsData.breakdown.map((item, index) => (
                    <div key={index} className="mb-4">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="fw-semibold">{item.category}</span>
                        <span className="text-muted">
                          ${item.amount} ({item.percentage}%)
                        </span>
                      </div>
                      <div className="progress" style={{ height: "8px" }}>
                        <div
                          className={`progress-bar bg-${
                            index % 2 === 0 ? "primary" : "success"
                          }`}
                          style={{ width: `${item.percentage}%` }}
                        ></div>
                      </div>
                    </div>
                  ))}
                  <div className="card bg-light mt-4">
                    <div className="card-body text-center">
                      <h5 className="text-primary mb-1">Total Year-to-Date</h5>
                      <h3 className="text-primary">
                        ${paymentsData.summary.yearToDate}
                      </h3>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentsHistory;
